import React from 'react'
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'

import { useAppConfig } from '../hooks/useAppConfig'

import { AuthRoute } from './AuthRoute'
import { MainLayout } from './MainLayout'
import { Routes } from './routes'

export const AppRoutes: React.FC = () => {
  const { t } = useTranslation(['routes'])
  const { availableLanguages, routes, routesComponentConfig } = useAppConfig()

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        {_.map(availableLanguages, availableLang => (
          <Route path={`/${availableLang}`} key={availableLang} element={<MainLayout />}>
            {_.map(routes, (config, key) => {
              if (!config) return null
              const { localizationKey, authorized, excludeFromRouter, requiredRole, ...rest } = config
              const { component, createConfig } = routesComponentConfig[key] || {}
              if (!component || excludeFromRouter) return null
              let localizedUrl = t(localizationKey || key, { lng: availableLang })
              if (!_.startsWith(localizedUrl, '/')) localizedUrl = `/${localizedUrl}`
              let path = `${localizedUrl.substring(1)}`
              if (key === Routes.Checkout) path = `${path}/*`

              if (authorized) {
                return (
                  <Route
                    key={key}
                    {...rest}
                    path={path}
                    element={
                      <AuthRoute requiredRole={requiredRole} component={component} createConfig={createConfig} />
                    }
                  />
                )
              }

              return (
                <Route
                  key={key}
                  {...rest}
                  path={path}
                  element={React.createElement(component, { route: key, config: createConfig })}
                />
              )
            })}
          </Route>
        ))}
      </>
    )
  )

  return <RouterProvider router={router} />
}
